import React from "react";
import StartStep from "../../components/StartStep/StartStep";
import GreyCard from "../../components/GreyCard/GreyCard";
import MyCard from "../../components/MyCard/MyCard";
import Row from "react-bootstrap/Row";
import {Button, Col, ProgressBar} from "react-bootstrap";
import Container from "react-bootstrap/Container";

const AboutUs = () => {
    return (
        <div>
            <StartStep>
                <h1>Москва. Подразделения и учебные офисы образовательных программ НИУ ВШЭ</h1>
            </StartStep>

            <GreyCard>
                <h2>Кампус в Москве: Столовые и буфеты</h2>
                <h2>Адреса:</h2>
                <ul>
                    <li> Армянский пер., д.4, стр.2</li>
                    <li>Вавилова, д. 7</li>
                    <li>М.Гнездниковский пер., д.4</li>
                    <li>Космонавта Волкова, д.18</li>
                    <li>Мясницкая, 11</li>
                    <li>Мясницкая, 20</li>
                    <li>Большая Ордынка, 47/7</li>
                    <li>М.Ордынка, 17</li>
                    <li>М.Ордынка, 29</li>
                    <li>Б.Переяславская ул., д.50</li>
                    <li>М.Пионерская ул., 12/4</li>
                    <li>Покровский бульвар, д. 11</li>
                    <li>Потаповский пер., д.16, стр.10</li>
                    <li>1-й Саратовский пр-д, д. 5, корп. 2</li>
                    <li>Старая Басманная, 21/4 стр. 1, стр. 5, стр. 6</li>
                    <li>Таллинская ул., д.34</li>
                    <li>Б.Трехсвятительский пер., 3</li>
                    <li>М.Трехсвятительский пер., 8/2, стр.1</li>
                    <li>Трифоновская ул., д.57</li>
                    <li>Усачева, 6</li>
                    <li>Хитровский пер., 2/8, стр.5</li>
                    <li>Шаболовка, 26, стр. 4</li>
                    <li>Шаболовка, 28/11, стр.2</li>
                    <li>МО, Одинцовский р-н, пос. ВНИИССОК, ул. Д.Давыдова, д.3</li>
                </ul>
                <p><a href="https://www.hse.ru/buildinghse/list#arm">Здания НИУ ВШЭ </a></p>
                <br/><br/>
                <hr/>
                <h2>Документы:</h2>
                <p>
                    <a href="https://www.hse.ru/mirror/pubs/share/461292020.pdf">Регламент контроля организации и
                        качества питания</a>
                    <br/>
                    <a href="https://www.hse.ru/buildinghse/dining/protocols">Протоколы совещаний по вопросу комплексных
                        обедов</a>
                    <br/>
                    <a href="https://www.hse.ru/mirror/pubs/share/796539246.xlsx">Состав Комиссий по вопросам
                        общественного питания с изм. от 25.10.2022</a>
                </p>
            </GreyCard>

            <br/><br/>

            <MyCard>
                <h2>Медпункты расположены в зданиях по адресам:</h2>
                <ul>
                    <li> г. Москва, Покровский бульвар, д. 11, стр. 1, корпус М, кабинеты 106-107 (Тел.: +7 (495) 772 95
                        90 доб. 27862)
                    </li>
                    <li> г. Москва, ул. Мясницкая, д. 11, первый этаж, кабинет 116 (Тел.: +7 (495) 628 23 74; +7 (495)
                        772 95 90 доб. 15595)
                    </li>
                    <li> г. Москва, ул. Шаболовка, д. 28/11, стр. 2, кабинеты 2114 (Тел.: +7 (495) 772 95 90 доб.
                        26308)
                    </li>
                    <li> г. Москва, ул. Старая Басманная, д. 21/4, стр. 5, кабинет 402 (Тел.: +7 (495) 772 95 90 доб.
                        23736)
                    </li>
                    <li> г. Москва, ул. Таллинская, д. 34, кабинет 134-135 (Тел.: +7 (495) 772 95 90 доб. 23498)</li>
                    <li> <b>Лицей НИУ ВШЭ:</b> </li>
                        <li> г. Москва, 3-й Колобовский пер., д. 8, стр. 2, каб. 103-104, (Тел.: +7 (495) 772 95 90 доб.
                            22614)
                        </li>
                        <li> г. Москва, Большой Харитоньевский пер., д. 4, стр. 1, каб. 203 (Тел.: +7 (495) 772 95 90
                            доб. 22125)
                        </li>
                        <li> г. Москва, ул. Солянка, д. 14А, каб. 101 (Тел.: +7 (495) 772 95 90 доб. 23325)</li>
                        <li> г. Москва, Лялин пер., д. 3 а, каб. 101 (Тел.: +7 (495) 772 95 90 доб. 23044)</li>
                </ul>
                <br/>
                <p><a href="https://benefits.hse.ru/med_kabinet">Подробно о медпунктах</a></p>
            </MyCard>

            <Container>
                <Row className="justify-content-md-center">
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step3">Назад</Button>{' '}
                    </Col>
                    <Col md={1}></Col>
                    <Col md={6} style={{ textAlign: "center", paddingTop: "6px"}}>
                        <ProgressBar now={36}/>
                        <span>Шаг 4 из 11</span>
                    </Col>
                    <Col md={1}></Col>
                    <Col md={2}>
                        <Button variant="outline-primary" style={{width: "100%"}} href="/step5">Вперед</Button>{' '}
                    </Col>
                </Row>
            </Container>
        </div>
);
};

export default AboutUs;